import { useForm } from "react-hook-form";
import { useCallback } from "react";

const defaultValues = { name: "", permissionIds: [] };

export const useRoleForm = () => {
  const { control, handleSubmit, reset } = useForm({
    defaultValues,
    mode: "onTouched",
  });

  const resetForm = useCallback(() => {
    reset(defaultValues);
  }, [reset]);

  const prefillForm = useCallback(
    (role) => {
      reset(
        {
          name: role.name || "",
          permissionIds: role.permissions?.map((p) => p.id) || [],
        },
        { keepDefaultValues: true },
      );
    },
    [reset],
  );

  return {
    control,
    handleSubmit,
    resetForm,
    prefillForm,
  };
};

export default useRoleForm;
